import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export type AskSimpoEntity = 'chat' | 'project' | 'crm_leads';

export interface AskSimpoChangeEvent {
  entity: AskSimpoEntity;
  /** The raw message type from the iframe, e.g. `asksimpo_chat_created` or `asksimpo_crm_leads_changed`. */
  type: string;
  data?: any;
}

/**
 * Bridge for "data changed" signals coming out of the Ask Simpo iframe.
 * `AskSimpoWrapperComponent` (which owns the iframe `message` listener) calls
 * `emit()`; subscribers can refresh affected CRM lists, chats, or projects.
 */
@Injectable({ providedIn: 'root' })
export class AskSimpoEventsService {
  readonly changed$ = new Subject<AskSimpoChangeEvent>();

  emit(entity: AskSimpoEntity, type: string, data?: any): void {
    this.changed$.next({ entity, type, data });
  }
}
